import { DirectUpload } from "@rails/activestorage";
import {
  activeStorageBlobUrl,
  directUploadPath,
} from "@/react/helpers/urlHelpers";

interface UploadTemplateAttachmentProps {
  file: File;
}

interface DirectUploadResult {
  signed_id: string;
  url: string;
}

export const uploadTemplateAttachment = async ({
  file,
}: UploadTemplateAttachmentProps): Promise<DirectUploadResult> =>
  new Promise((resolve, reject) => {
    const upload = new DirectUpload(file, directUploadPath(), {
      directUploadWillStoreFileWithXHR: xhr => {
        xhr.upload.addEventListener("error", () => {
          reject(new Error("Upload failed"));
        });
      },
    });

    upload.create((error, response) => {
      if (error) {
        reject(new Error(`Direct upload failed: ${error?.message}`));
      } else {
        resolve({
          url: activeStorageBlobUrl({
            signed_id: response.signed_id,
            filename: encodeURIComponent(response.filename),
          }),
          signed_id: response.signed_id,
        });
      }
    });
  });
